import { OutGoingState } from "../interfaces/outGoing"
import { Types } from "../types"
import { OutGoingActions } from "../types/outGoing/actionsType"









const initialState: OutGoingState = {

    outGoingPending: false,
    outGoingSuccess: false,
    outGoingError: ''


}


const outGoingReducer = (state = initialState, action: OutGoingActions) => {
    switch (action.type) {
        case Types.OUGOING_CALL_REQUEST:
            return {
                ...state,
                outGoingPending: true,
                outGoingSuccess: false,
                outGoingError: ''
            }
        case Types.OUGOING_CALL_SUCCESS:
            return {
                ...state,
                outGoingPending: false,
                outGoingSuccess: true,
                outGoingError: ''
            }
        case Types.OUGOING_CALL_ERROR:
            return {
                ...state,
                outGoingPending: false,
                outGoingSuccess: false,
                outGoingError: action.payload.error
            }

        case Types.RESET_OUTGOING_CALL:
            return {
                ...state,
                outGoingPending: false,
                outGoingSuccess: false,
                outGoingError: ''
            }





        default:
            return {
                ...state
            }

    }
}

export default outGoingReducer
